import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=37bf881d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=37bf881d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf881d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bf881d')) {
      api.createRecord('37bf881d', component.options)
    } else {
      api.reload('37bf881d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=37bf881d&scoped=true&", function () {
      api.rerender('37bf881d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/PopupDialog.vue"
export default component.exports